import { render, staticRenderFns } from "./MetaContent.vue?vue&type=template&id=4c4d36dd&scoped=true"
import script from "./MetaContent.vue?vue&type=script&lang=js"
export * from "./MetaContent.vue?vue&type=script&lang=js"
import style0 from "./MetaContent.vue?vue&type=style&index=0&id=4c4d36dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d36dd",
  null
  
)

export default component.exports